<template>
  <div></div>
</template>

<script>
  export default {
    name: 'ProductPlaceholder',
  };
</script>
